import {IndexPage} from '../../provider-mappings/pages/IndexPage';

export const PriceProviderMappings = ({ priceId }: { priceId: string }) => {
    return <IndexPage priceId={priceId} />;
};